import { AsyncComponent } from '@frontend/components/common';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const FunctionalityCreate = lazy(() => import('./functionality-create/functionality-create.component'));
const FunctionalityDetail = lazy(() => import('./functionality-detail/functionality-detail.component'));
const FunctionalitiesOverview = lazy(() => import('./functionality-overview'));
const FunctionalityUpdate = lazy(() => import('./functionality-update/functionality-update.component'));

export function FunctionalityRoutes() {
    return (
        <Route path='functionalities'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <FunctionalitiesOverview />
                    </AsyncComponent>
                }
            />
            <Route
                path='create'
                element={
                    <AsyncComponent>
                        <FunctionalityCreate />
                    </AsyncComponent>
                }
            />
            <Route path=':functionalityId'>
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <FunctionalityDetail />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='update'
                    element={
                        <AsyncComponent>
                            <FunctionalityUpdate />
                        </AsyncComponent>
                    }
                />
            </Route>
        </Route>
    );
}
